'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkButton from '@/components/atoms/LinkButton';
import { useCryptos } from '@/hooks/UseCryptos';
import ArrowDown from '@/public/assets/svg/arrow-down.svg';
import ArrowUp from '@/public/assets/svg/arrow-up.svg';
import CryptoCarouselItemSkeleton from './SliderItemSkeleton';
import { CryptosCarouselProps } from './types';
const CryptosCarousel: React.FC<CryptosCarouselProps> = t0 => {
  const $ = _c(12);
  const {
    button,
    coins
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: true,
      align: "start"
    };
    t2 = [Autoplay({
      delay: 4000,
      stopOnInteraction: false
    })];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const [emblaRef] = useEmblaCarousel(t1, t2);
  let t3;
  if ($[2] !== coins) {
    t3 = {
      coins
    };
    $[2] = coins;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    isLoading: isLoadingCryptos,
    data: slides
  } = useCryptos(t3);
  let t4;
  if ($[4] !== button?.link || $[5] !== button?.text || $[6] !== emblaRef || $[7] !== isLoadingCryptos || $[8] !== slides?.error || $[9] !== slides?.result || $[10] !== t) {
    t4 = slides?.error ? <div className="o-container o-container--xl my-8" data-sentry-component="CryptosCarousel" data-sentry-source-file="index.tsx"><div className="text-body-7 flex items-center justify-center rounded-lg border border-gray-200 p-8 font-bold">{slides?.error}</div></div> : <div className="relative" data-sentry-component="CryptosCarousel" data-sentry-source-file="index.tsx"><div className="overflow-hidden" ref={emblaRef}><div className="ml-4 flex lg:ml-4">{isLoadingCryptos && Array.from({
            length: 5
          }).map(_temp)}{slides?.result?.map(slide => <div className="min-w-mobileSlider shadow-elevation-4 lg:min-w-slider relative mt-16 mr-5 mb-10 overflow-visible rounded-[0.625rem] border border-gray-200 px-8 pt-9 pb-8 lg:mt-28 lg:mb-12 lg:px-7" key={slide.label}><PrismicNextImage fallbackAlt="" width={48} height={48} className="absolute top-0 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2" field={slide.icon} /><p className="text-h6 pb-1 text-center font-bold">{slide.label}</p><p className="text-caption-2 pb-6 text-center font-medium text-gray-500">{slide.ticker}/{slide.currencyCode}</p><div className="flex w-full justify-between border-t border-gray-200 py-5"><div className="flex"><ArrowUp /> {t("atmPage.coins.buyLabel")}</div><span className="text-h8 font-bold">{slide.buyValue}</span></div><div className="flex w-full justify-between border-t border-gray-200 pt-5"><div className="flex"><ArrowDown /> {t("atmPage.coins.sellLabel")}</div><span className="text-h8 font-bold">{slide.sellValue}</span></div></div>)}</div><LinkButton className="mx-auto w-fit px-6 text-center" field={button?.link} variant="outline" data-sentry-element="LinkButton" data-sentry-source-file="index.tsx">{button?.text || "Explore more"}</LinkButton></div></div>;
    $[4] = button?.link;
    $[5] = button?.text;
    $[6] = emblaRef;
    $[7] = isLoadingCryptos;
    $[8] = slides?.error;
    $[9] = slides?.result;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default CryptosCarousel;
function _temp(_, index) {
  return <CryptoCarouselItemSkeleton key={index} />;
}